// Variant Selection Logic
let inputs = document.querySelectorAll(".card-form input[type='radio']");

document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("variant-head") ||
    e.target.closest(".variant-head")
  ) {
    let el = e.target.classList.contains("variant-head")
      ? e.target
      : e.target.closest(".variant-head");
    el.closest(".dropdown").classList.toggle("open");
  }
});

inputs.forEach(function (el) {
  el.addEventListener("change", function (e) {
    let form = el.closest("form");
    let data = JSON.parse(form.querySelector("script").innerText);
    let formInput = form.querySelector('input[name="id"]');
    let ajaxButton = form.querySelector(".ajax-cart");
    let image1 = form.closest(".product-card").querySelector(".card-image-wrap img");
    let image2 = form.closest(".product-card").querySelector(".product-image-2");
    
    // Initialize selected options array based on product's option order
    let selectedOptions = [];
    data.options.forEach(function(optionName) {
      let inputName = data.id + '-' + optionName;
      let selectedInput = form.querySelector('input[name="' + inputName + '"]:checked');
      selectedOptions.push(selectedInput ? selectedInput.value : null);
    });
    // Find matching variant
    let selectedOptionData = data.variants.find(variant => 
      variant.option1 === selectedOptions[0]
    );
    if (selectedOptionData) {
      // Update variant ID
      
      formInput.value = selectedOptionData.id;
      // Update availability
      if (ajaxButton) {
        ajaxButton.toggleAttribute("disabled", !selectedOptionData.available);
        ajaxButton.dataset.variantId = selectedOptionData.id; // Add variant ID to button
      }

      // Update images
      if (image1 && selectedOptionData.featured_image?.src) {
        image1.src = selectedOptionData.featured_image.src;
        image1.srcset = selectedOptionData.featured_image.src;
      }
      
      if (image2) {
        image2.style.display = "none";
      }
    }
  });
});

// Disable Unavailable Variants
const disableUnavailableVariantCollection = function () {
  document.querySelectorAll(".card-form").forEach((form) => {
    let data = JSON.parse(form.querySelector("script").innerText);
    
    data.variants.forEach((variant) => {
      if (!variant.available) {
        variant.options.forEach((optionValue, index) => {
          let optionName = data.options[index];
          let input = form.querySelector(`.card-option input[value="${optionValue}"]`);
          
          if (input) {
            input.disabled = true;
            input.closest('.card-option').classList.add('disableTrue');
          }
        });
      }
    });
  });
};

// Initialize variant disabling
disableUnavailableVariantCollection();